const cfg = {
	name: "华创集团综合办公系统",
	version: "3.1.8",
	server: "http://192.168.1.156:6030/",
	upload: "http://192.168.1.156:6030/oa3/pc/server/upload.php",
	apikey: "7b6ac9a6e139d7fd49b00a10c15a7f0c"
}

export default cfg
